export default __webpack_public_path__ + "static/media/camera.c00d412a.svg";